import * as service from "../service";
import type { ServiceResponse } from "../types";

export type SponsorQuantityCap = {
  quantityPerParticipantHkd: number;
  maxParticipants: number;
};

export const GetSponsorQuantityCapAPI = async (): Promise<
  ServiceResponse<SponsorQuantityCap>
> => {
  try {
    const resp = (await service.call(
      "GET",
      "api/sponsor/quantityCap",
    )) as ServiceResponse<SponsorQuantityCap>;
    if (resp?.status !== 0 || !resp.result) {
      return {
        status: resp?.status ?? -1,
        result: { quantityPerParticipantHkd: 1, maxParticipants: 500 },
      };
    }
    return {
      status: 0,
      result: {
        quantityPerParticipantHkd: Number(resp.result.quantityPerParticipantHkd) || 1,
        maxParticipants: Number(resp.result.maxParticipants) || 500,
      },
    };
  } catch (err) {
    console.error(`GetSponsorQuantityCapAPI ${err}`);
    return {
      status: -1,
      result: { quantityPerParticipantHkd: 1, maxParticipants: 500 },
      error: err,
    };
  }
};